exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2cNRIcG2vCkjIIUGTa1l0K {\n    display: flex;\n    justify-content: center;\n    visibility: hidden;\n    height: 0;\n    overflow: hidden;\n}\n\n.carousel-inner > .item {\n    height: 100%;\n    align-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"desktop-layout-measurement": "_2cNRIcG2vCkjIIUGTa1l0K",
	"desktopLayoutMeasurement": "_2cNRIcG2vCkjIIUGTa1l0K"
};